import { Component } from '@angular/core';

@Component({
  selector: 'ppt-record-floor-plan',
  templateUrl: './record-floor-plan.component.html',
  styleUrls: ['./record-floor-plan.component.scss'],
  standalone: false,
})
export class RecordFloorPlanComponent {}
